// import { useQuery } from "@apollo/client";
import gql from "graphql-tag";

// GQL
// Making Updates to this query? Please match the update in
// `noun_project/notifications/test_marketing_header_message_graphql.py`
// on`marketingHeaderMessage` - we pre-cache this query in Apollo SSR
export const GET_MARKETING_MESSAGE_MODAL = gql`
    query marketingHeaderMessage {
        marketingHeaderMessage {
            ctaTarget
            ctaText
            ctaUrl
            headerMessage
            modalHeadline
            modalImageUrl
            modalMessage
        }
    }
`;

export const useMarketingMessageModal = () => {
    // disable for now until we figure out what we want to do with MMM
    // const { data: resp, error, loading, refetch } = useQuery(
    //     GET_MARKETING_MESSAGE_MODAL,
    //     {
    //         fetchPolicy: "cache-first"
    //     }
    // );

    const refetchUserMessage = () => {
        // refetch();
    };

    // const userMessage =
    //     (!loading && !error && resp?.marketingHeaderMessage) ?? null;

    let error;

    return {
        userMessage: null,
        error,
        loading: false,
        refetchUserMessage
    };
};
